import React, { Fragment, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import profile01 from "../../../../images/profile/1.jpg";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  saveoutletDetails,
  updateletDetails,
  getoutletListMaster,
} from "../../../../apiservicescall/api";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
} from "reactstrap";
import { Row, Card, Col, Button, Container } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import BankDetails from "./OutletManagmentInformation/BankDetails";
import Fssi from "./OutletManagmentInformation/Fssi";
import KycDetails from "./OutletManagmentInformation/KycDetails";
import Home from "./OutletManagmentInformation/Home";
import OutletWorkingHours from "./OutletManagmentInformation/OutletWorkingHours";
import OutletDetails from "./OutletManagmentInformation/PersonalDetails";
import Map from "./Map";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import {
  useForm,
  Controller,
  FormProvider,
  useFormContext,
} from "react-hook-form";
import { CssBaseline, Paper, Box } from "@material-ui/core";
import Select from "react-select";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import { NotificationManager } from "react-notifications";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Switch from "@material-ui/core/Switch";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import food1 from "./../../../../images/foods/food1.jpg";

function TabContainer({ children }) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

const OrderList = ({ props }) => {
  const [activeToggle, setActiveToggle] = useState("posts");
  const [sendMessage, setSendMessage] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [cameraModal, setCameraModal] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const [replayModal, setReplayModal] = useState(false);
  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [openImagePopup, setOpenImagePopup] = useState();

  //stepper:
  const [activeStep, setActiveStep] = useState(0);
  // const [skippedSteps, setSkippedSteps] = useState([]);
  // const steps = getSteps();
  const [popupModal, setPopupModal] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const [contentModal, setContentModal] = useState(false);
  const [modalCentered, setModalCentered] = useState(false);
  const [modalWithTooltip, setModalWithTooltip] = useState(false);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [largeModal, setLargeModal] = useState(false);
  const [smallModal, setSmallModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());

  const [bankMaster, setBankMaster] = useState([
    { label: "Bank of Baroda", value: "Bank of Baroda" },
    { label: "Bank of India", value: "Bank of India" },
    { label: "Canara Bank", value: "Canara Bank" },
    { label: "Indian Bank", value: "Indian Bank" },
    { label: "Indian Overseas Bank", value: "Indian Overseas Bank" },
    { label: "Union Bank of India", value: "Union Bank of India" },
    { label: "State Bank of India", value: "State Bank of India" },
    { label: "Axis Bank", value: "Axis Bank" },
    { label: "City Union Bank", value: "City Union Bank" },
    { label: "HDFC Bank", value: "HDFC Bank" },
    { label: "ICICI Bank", value: "ICICIBank" },
    { label: "Other Bank", value: "OtherBank" },
  ]);

  const [outletBankNameValue, setOutletBankNameValue] = useState({
    label: "",
    value: "",
  });

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [outletDetails, setOutletDetails] = useState({
    // Outlet Personal
    outletName: "",
    outletCode: "",
    outletMobileNumber: "",
    outletEmailId: "",
    outletContactPerson: "",
    compCode: userDetails?.companyCode,
    // Address,
    outletState: "",
    outletCity: "",
    outletArea: "",
    outletAddress: "",
    outletpinCode: "",
    outletLattitude: "",
    outletLandititude: "",
    // KYC Details
    outletGstNumber: "",
    outletPanNumber: "",
    outletFssaiRegNumber: "",
    // KYC Images
    outletGstFile: "",
    outletPanFile: "",
    outletFssaiFile: "",
    outletOutdoorPhoto: "",
    outletinteriorsPhoto: "",
    outletFssaiFilePath: "",
    outletGstFilePath: "",
    outletOutdoorPath: "",
    outletPanFilePath: "",
    // BankDetails
    outletBankName: "",
    outletBankACNumber: "",
    outletAccountHolderName: "",
    outletIFSCcode: "",
    outletfoodVegcategory: true,
    outletfoodNonVegcategory: false,
    outletFoodType: "",
    activeStatus: "A",
  });

  //json//
  const [orderdetails, setOrderdetails] = useState([
    {
      customername: "Test user",
      mobileno: "9652417895",
      orderno: "96541",
      date: "12/16/2022",
      paymentmode: "G-PAY",
      foodtype: "veg",
      totalqty: "1",
      packingcharges: "RS.10",
      deliverycharges: "RS.200",
      totalamount: "RS.210",
      orderstatus: "",
      deliverstatus: "Delivered",
      deliveryperson: "Testuser",
      deliverypoint: "Nehru nagar",
      deliverlocation: "chennai",
      createdby: "12/16/2022",
      updatedby: "12/16/2022",

    },
    {
      customername: "Admin",
      mobileno: "9652012356",
      orderno: "6321",
      date: "12/16/2022",
      paymentmode: "COD",
      foodtype: "veg",
      totalqty: "3",
      packingcharges: "RS.10",
      deliverycharges: "RS.300",
      totalamount: "RS.310",
      orderstatus: "",
      deliverstatus: "Delivered",
      deliveryperson: "Testuser",
      deliverypoint: "Nehru nagar",
      deliverlocation: "Guindy",
      createdby: "12/16/2022",
      updatedby: "12/16/2022",
    },


  ]);

  let [formIsValid, setFormIsValid] = useState(false);
  let [errors, setErrors] = useState({
    // Outlet Personal
    outletName: null,
    outletMobileNumber: null,
    outletEmailId: null,
    outletContactPerson: null,
    // // Address State / City  : null,
    // outletState: null,
    // outletCity: null,
    // outletArea: null,
    // outletAddress: null,
    // outletpinCode: null,
    // outletLattitude: null,
    // outletLandititude: null,

    // // KYC Details
    outletGstNumber: null,
    outletPanNumber: null,
    outletFssaiRegNumber: null,

    // // KYC Images
    outletGstFile: null,
    outletPanFile: null,
    outletFssaiFile: null,

    // // BankDetails
    outletBankName: null,
    outletBankACNumber: null,
    outletAccountHolderName: null,
    outletIFSCcode: null,

    // outletOutdoorPhoto: null,
    outletinteriorsPhoto: null,
  });
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [editOutletobj, setEditOutletobj] = useState({});
  let [editCall, setEditCall] = useState(false);

  useEffect(() => {
    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    let companyCode = userDetails?.companyCode;
    getoutletList(companyCode);
    if (editCall === true) {
      setEditCall(false);
      setOutletDetails({ ...outletDetails, ...editOutletobj });
    }
  }, [outletDetails]);

  const getoutletList = async (companyCode) => {

    let getoutletList = await getoutletListMaster(companyCode);

    let getoutletListValue = getoutletList?.data?.data;
    // console.log("getoutletListValue", getoutletListValue)
    setOutletMasterlist(getoutletListValue);
  };

  const saveupdateoutlet = async () => {
    let data = {
      // Outlet Personal
      compCode: userDetails?.companyCode,
      outletCode: outletDetails?.outletCode || "",
      outletName: outletDetails?.outletName || "",
      outletMobileNumber: outletDetails?.outletMobileNumber || "",
      outletEmailId: outletDetails?.outletEmailId || "",
      outletContactPerson: outletDetails?.outletContactPerson,
      // Address

      // outletAddress: outletDetails?.outletAddress,
      outletAddress:
        "NSIC Software Technology Park, 410,3rd Floor, Sector B24, Guindy Industrial Estate, Ekkaduthangal",
      // outletArea: outletDetails?.outletArea,
      // outletCity: outletDetails?.outletCity,

      outletArea: "Guindy,SIDCO Industrial Estate",
      outletCity: "Chennai",

      // outletpinCode: outletDetails?.outletpinCode || "",
      outletpinCode: "600032",
      // outletState: outletDetails?.outletState,
      outletState: "Tamil Nadu",
      // outletLandititude: outletDetails?.outletLandititude || "",
      // outletLattitude: outletDetails?.outletLattitude || "",

      outletLandititude: "12.983.21",
      outletLattitude: "14.83.21",
      // KYC Details
      outletAccountHolderName: outletDetails?.outletAccountHolderName || "",
      outletBankACNumber: outletDetails?.outletBankACNumber || "",
      outletBankName: outletBankNameValue?.value || "",
      outletPanNumber: outletDetails?.outletPanNumber || "",
      outletGstNumber: outletDetails?.outletGstNumber || "",
      outletIFSCcode: outletDetails?.outletIFSCcode || "",
      outletFssaiRegNumber: outletDetails?.outletFssaiRegNumber || "",
      // KYC Images
      outletGstFile: outletDetails?.outletGstFile || "",
      outletPanFile: outletDetails?.outletPanFile || "",
      // outletGstFile: outletDetails.outletGstFile,
      outletFssaiFile: outletDetails?.outletFssaiFile || "",
      outletOutdoorFile: outletDetails?.outletinteriorsPhoto || "",
      outletInteriorFile: outletDetails?.outletinteriorsPhoto || "",
      outletFoodType:
        outletDetails.outletfoodVegcategory === true &&
          outletDetails.outletfoodNonVegcategory === true
          ? "veg,nong-veg"
          : "veg",

      activeStatus: "A",
    };

    console.log("vjjv", data);

    let formData = new FormData();
    for (var key in data) {
      if (Array.isArray(data[key])) {
        data[key].forEach((obj, index) => {
          let keyName = [key, "[", index, "]"].join("");
          formData.append("file", obj);
        });
      } else {
        formData.append(key, data[key]);
      }
    }
    let reqforupload;

    if (isedit === false) {
      reqforupload = await saveoutletDetails(formData);
    } else {
      reqforupload = await updateletDetails(formData);
    }

    console.log("reqforupload", reqforupload);

    if (reqforupload?.status === 200) {
      setOutletDetails({});
      setOutletBankNameValue({});
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
      if (isedit === false) {
        swal("Success!", "Outlet Added", "success");
      } else {
        swal("Success!", "Outlet Updated", "success");
      }
      // await this.setState({ reload: false });
      // NotificationManager.success("Success");
      // this.setState({ addNewUserModal: false, loading: true });
    } else {
      // await this.setState({ reload: false });
      // NotificationManager.warning("Invalid Data Format");
      // this.setState({ addNewUserModal: true });
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
    }
  };

  const onChangeCommonpopup = (key, value) => {
    // 
    // console.log("key", key)
    // console.log("value", value)

    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;
    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const stringwithnumberPattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/;
    const mobilePattern = /^[5-9][0-9]{9}$/;
    const bankACNumber = /^[0-9]{9,18}$/;
    const emailPattern =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;
    const gstPattern =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    const aadhaarPattern = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/;
    const pancardrPattern = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const ifscPattern = /[A-Z]{4}0[A-Z0-9a-z]{6}$/;

    if (key == "outletName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletName"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    if (key == "outletMobileNumber") {
      if (value.length > 10) {
        return false;
      } else if (!mobilePattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletMobileNumber"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletMobileNumber"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    if (key == "outletEmailId") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletEmailId"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!emailPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletEmailId"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletEmailId"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    if (key == "outletContactPerson") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletContactPerson"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletContactPerson"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletContactPerson"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletGstNumber") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletGstNumber"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!gstPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletGstNumber"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletGstNumber"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletPanNumber") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletPanNumber"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!pancardrPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletPanNumber"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletPanNumber"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletFssaiRegNumber") {
      if (value.length > 25) {
        return false;
      } else if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletFssaiRegNumber"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletFssaiRegNumber"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletfoodVegcategory") {
      addFieldValue = { [key]: value };
      // errorsLocal["outletfoodVegcategory"] = "";
      // setErrors(errorsLocal);
      // formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      setFormIsValid(formIsValidLocal);
    }

    if (key == "outletfoodNonVegcategory") {
      addFieldValue = { [key]: value };
      // errorsLocal["outletfoodNonVegcategory"] = "";
      // setErrors(errorsLocal);
      // formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      setFormIsValid(formIsValidLocal);
    }

    if (key == "outletinteriorsPhoto") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletinteriorsPhoto"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        // addFieldValue = { [key]: value.target.files[0] };
        errorsLocal["outletinteriorsPhoto"] = "";
        setOutletDetails({
          outletinteriorsPhoto: value.target.files[0],
        });
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "webLogin") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["webLogin"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["webLogin"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletBankName") {
      if (!value) {
        addFieldValue = { [value.label]: null };
        errorsLocal["outletBankName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setOutletBankNameValue({
          label: value.label,
          value: value.value,
        });
        addFieldValue = { ["outletBankName"]: value.value };
        errorsLocal["outletBankName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletBankACNumber") {
      if (value.length > 20) {
        return false;
      } else if (!bankACNumber.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletBankACNumber"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletBankACNumber"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletAccountHolderName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletAccountHolderName"] = "Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletAccountHolderName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletAccountHolderName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletIFSCcode") {
      if (!ifscPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["outletIFSCcode"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (value.length > 15) {
        return false;
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["outletIFSCcode"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = { ...outletDetails };
    newFormData[key] = value;
    console.log("newFormDataonchange", newFormData);
    setOutletDetails(newFormData);
  };

  const onChangeCommonpopupFile = (key, value) => {
    
    // console.log("key", key)
    // console.log("value", value)
    // console.log("value", value.target.files[0])

    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    if (key == "outletinteriorsPhoto") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletinteriorsPhoto"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value.target.files[0] };
        errorsLocal["outletinteriorsPhoto"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletGstFile") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletGstFile"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value.target.files[0] };
        errorsLocal["outletGstFile"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletPanFile") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletPanFile"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value.target.files[0] };
        errorsLocal["outletPanFile"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "outletFssaiFile") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["outletFssaiFile"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value.target.files[0] };
        errorsLocal["outletFssaiFile"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = { ...outletDetails };
    newFormData[key] = value.target.files[0];
    console.log("fileconsole", newFormData);
    setOutletDetails(newFormData);
  };

  const onClose = () => {
    setOpenImagePopup(!openImagePopup);
  };

  // Refresh Page
  const reRender = (value) => {
    
    console.log("value123", value);
    console.log("lat", value?.mapPosition?.lat);
    console.log("lng", value?.mapPosition?.lng);
    setOutletDetails({
      outletState: value?.state || "",
      outletCity: value?.city || "",
      outletArea: value?.area || "",
      outletAddress: value?.address || "",
      outletLandititude: value?.mapPosition?.lat,
      outletLattitude: value?.mapPosition?.lng,
    });
  };

  // function getSteps() {
  //   return ["Outlet Details", "Kyc Details", "Location", "Bank Details"];
  // }

  // function getStepContent(step) {
  //   switch (step) {
  //     case 0:
  //       return <OutletDetails />;

  //     case 1:
  //       return <KycDetails />;

  //     case 2:
  //       return <Home />;
  //     case 3:
  //       return <BankDetails />;
  //     /*  default:
  //        return "unknown step"; */
  //   }
  // }
  // const skippedSteps = () => {
  //   return skipped.size;
  // }

  // const isStepOptional = (step) => {
  //   return step === 1 || step === 2;
  // };

  // const isStepSkipped = (step) => {
  //   return skipped.has(step);
  // };

  // const totalSteps = () => {
  //   return getSteps().length;
  // };

  // const isLastStep = () => {
  //   return activeStep === totalSteps() - 1;
  // };

  // const completedSteps = () => {
  //   return completed.size;
  // };

  // const allStepsCompleted = () => {
  //   return completedSteps() === totalSteps() - skippedSteps();
  // };

  // const handleNext = () => {
  //   let activeStep2 = "";
  //   const {
  //     restName,
  //     restMobileNumber,
  //     restEmailId,
  //     reststateName,
  //     restcityName,
  //     restPincodeName,
  //     restGstNumber,
  //     restPanNumber,
  //     restGstFile,
  //     restPanFile,
  //     restOutdoorPhoto,
  //     restIndoorPhoto,
  //     restBankAcNumber,
  //     restBankName,
  //     restIFSCNO,
  //   } = outletDetails;

  //   if (activeStep === 0) {
  //     if (outletDetails === null &&
  //       restName !== "" &&
  //       restMobileNumber !== "" &&
  //       restEmailId !== "") {
  //       NotificationManager.warning("ALL Field is mandatory..!!");
  //       return false;
  //     }

  //   }

  //   if (isLastStep() && !allStepsCompleted()) {

  //     // It's the last step, but not all steps have been completed
  //     // find the first step that has been completed
  //     const steps = getSteps();
  //     activeStep2 = steps.findIndex((step, i) => !completed.has(i));
  //   } else {
  //     activeStep2 = activeStep + 1;
  //   }

  //   const completed2 = new Set(completed);
  //   completed2.add(activeStep);
  //   setActiveStep(activeStep2);
  //   setCompleted(completed2);
  // };

  // const handleStep = (step) => () => {
  //   setOutletDetails(outletDetails);
  //   setActiveStep(step);
  // };

  // const handleBack = () => {
  //   setActiveStep(activeStep - 1);
  // };

  // const handleSkip = () => {
  //   if (!isStepSkipped(activeStep)) {
  //     setSkipped([...skipped, activeStep]);
  //   }
  //   setActiveStep(activeStep + 1);
  // };

  // const handleReset = () => {
  //   this.setState({
  //     activeStep: 0,
  //     completed: new Set(),
  //     skipped: new Set(),
  //   });
  // };

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    setLargeModal(!largeModal);
    setIsview(false);
    setIsedit(false);
  };

  const onEditUser = (data) => {
    let selectedUser = outletMasterlist.find(
      (value, index) => index === data?.rowIndex
    );
    console.log("selectedUser12321", selectedUser);
    console.log("selectedUser123999", selectedUser.outletName);

    // const newFormData = { ...outletDetails };
    // newFormData[key] = value;
    // console.log("newFormDataonchange", newFormData);
    // setOutletDetails(newFormData);
    //   setState(prevState => ({
    //     ...prevState,
    //     [name]: value
    // }));

    // setOutletDetails((selectedUser) => ({
    //   outletName: selectedUser.outletName,
    // }));

    // setOutletDetails((outletDetails) =>  { ...outletDetails, outletName: selectedUser.outletName });

    // setOutletDetails(outletDetails => {
    //   return {
    //     ...outletDetails,
    // // ...selectedUser
    //     outletName: selectedUser.outletName
    //   }
    // });

    // setOutletDetails(outletDetails => ([{
    //   ...outletDetails,
    //   ...selectedUser
    // }]));

    // setOutletDetails(
    //   {},
    //   () => {
    //     setOutletDetails({ ...outletDetails, ...selectedUser });
    //   }
    // );

    // setOutletDetails({ ...outletDetails, ...selectedUser });
    // setOutletDetails({ ...selectedUser });
    // setOutletDetails({ outletName: selectedUser.outletName });

    setEditOutletobj({ ...outletDetails, ...selectedUser });
    setEditCall(true);

    const tempstatemaster = bankMaster
      .filter((item) => item.value == selectedUser.outletBankName)
      .map(({ value, label }) => ({ value: value, label: label }));
    console.log("tempstatemaster", tempstatemaster);
    setOutletBankNameValue(tempstatemaster);

    setLargeModal(true);
    setIsedit(true);
    setErrors({});
    setFormIsValid(true);
    setIsview(false);
    console.log("outletDetailsedit", outletDetails);

    // setEditOutletobj({ outletName: selectedUser.outletName });
    // setOutletDetails({
    //   outletName: selectedUser.outletName,
    //   outletCode: selectedUser.outletCode,
    //   outletMobileNumber: selectedUser.outletMobileNumber,
    //   outletEmailId: selectedUser.outletEmailId,
    //   outletContactPerson: selectedUser.outletContactPerson,
    //   outletGstNumber: selectedUser.outletGstNumber,
    //   outletPanNumber: selectedUser.outletPanNumber,
    //   outletFssaiRegNumber: selectedUser.outletFssaiRegNumber,
    //   // KYC Images
    //   outletGstFile: selectedUser.outletGstFile,
    //   outletPanFile: selectedUser.outletPanFile,
    //   outletFssaiFile: selectedUser.outletFssaiFile,
    //   outletOutdoorPhoto: selectedUser.outletOutdoorPhoto,
    //   outletinteriorsPhoto: selectedUser.outletinteriorsPhoto,
    //   outletAddress: selectedUser.outletAddress,
    //   outletArea: selectedUser.outletArea,
    //   outletCity: selectedUser.outletCity,
    //   outletpinCode: selectedUser.outletpinCode,
    //   outletState: selectedUser.outletState,
    //   outletLattitude: selectedUser.outletLattitude,
    //   outletLandititude: selectedUser.outletLandititude,
    //   outletBankName: selectedUser.outletBankName,
    //   outletBankACNumber: selectedUser.outletBankACNumber,
    //   outletAccountHolderName: selectedUser.outletAccountHolderName,
    //   outletIFSCcode: selectedUser.outletIFSCcode,
    //   outletFoodType: selectedUser.outletFoodType,
    //   outletfoodVegcategory: selectedUser.outletFoodType == "veg" ? true : false || "",
    //   outletfoodNonVegcategory: selectedUser.outletFoodType == "veg" ? true : false || ""
    // });
  };

  const viewUser = (data) => {
    let selectedUser = outletMasterlist.find(
      (value, index) => index === data?.rowIndex
    );
    console.log("selectedUser12321", selectedUser);
    console.log("selectedUser123999", selectedUser.outletName);

    // let activeStatus = selectedUser.activeStatus == "A" ? true : false;

    setEditOutletobj({
      ...outletDetails,
      ...selectedUser,
      ...(selectedUser.activeStatus == "A" ? false : true),
    });
    setEditCall(true);

    const tempstatemaster = bankMaster
      .filter((item) => item.value == selectedUser.outletBankName)
      .map(({ value, label }) => ({ value: value, label: label }));
    console.log("tempstatemaster", tempstatemaster);
    setOutletBankNameValue(tempstatemaster);

    setLargeModal(true);
    setIsview(true);
    setIsedit(false);
    setErrors({});
    setFormIsValid(true);
    console.log("outletDetailsedit", outletDetails);
  };

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        // console.log("rowData[11] ", tableMeta.rowData[11])
        return (
          <div className="list-action">
            <span style={{ color: "black" }} className="icon-top-left">
              {/* <button
                type="button"
                className="rct-link-btn edit-btn"
                onClick={() => onEditUser(tableMeta)}
              >
                <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
              </button> */}

              <Link
                className="btn btn-primary shadow btn-xs sharp me-2"
                onClick={() => {
                  // setOutletDetails({})
                  onEditUser(tableMeta);
                }}
                style={{ background: "#008000" }}
              >
                <i className="fas fa-pencil-alt fa-lg"></i>
              </Link>

              {/* <Link
                className="btn btn-primary shadow btn-xs sharp me-2"
                onClick={() => {
                   setOutletDetails({})
                  viewUser(tableMeta);
                }}
                style={{ background: "#008000" }}
              >
                <i className="fa fa-eye"></i>
              </Link> */}
            </span>

            {/* <span style={{ paddingLeft: "20px",marginTop: "-20px" }} className="icon-top-left">

              <Link className="btn btn-primary shadow btn-xs sharp me-2"
                onClick={() => viewUser(tableMeta)} style={{ background: "#008000" }}
              >
                <i className="fa fa-eye"></i>
              </Link>
            </span> */}
          </div>
        );
      },
    },
  };

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#4cb32b",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  const columns = [
    actionOption,
    {
      name: "customername",
      label: "Name",
      options: {
        filter: false,
        sort: true,
        // customFilterListOptions: { render: v => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "mobileno",
      label: "Mobile Number",
      options: {
        filter: false,
        sort: true,
        // customFilterListOptions: { render: v => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "orderno",
      label: "Order No",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "date",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "paymentmode",
      label: "Payment Mode",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "foodtype",
      label: "Food Type",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "totalqty",
      label: "Total Qty",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "packingcharges",
      label: "Packing Charges",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "deliverycharges",
      label: "Del Charge",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },


    {
      name: "totalamount",
      label: "Total Amount",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },


    {
      name: "orderstatus",
      label: "Order Status",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "deliverstatus",
      label: "Delivery Status",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "deliveryperson",
      label: "Delivery Person",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "deliverypoint",
      label: "Delivery Point",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "deliverlocation",
      label: "Delivery Location",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "createdby",
      label: "Created By",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "updatedby",
      label: "Updated By",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
  ];

  const options = {
    filter: false,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },

    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    // search: false,
    // textLabels: {
    // 	body: {
    // 		noMatch: labelmessage
    // 	},
    // },

    fixedHeader: true,
    tableBodyHeight: "425px",

    fixedSelectColumn: true,
    search: false,
    // page: currentPage,

    pagination: false,
    serverSide: true,
    // rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    // onColumnSortChange: this.customSort,
    onChangePage: (page) => this.changePage(page),
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterVal,
      filterOptions,
      changedColumnIndex,
      displayData
    ) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        this.handleFilterSubmit(newFilters);
      }
    },

    onSearchChange: (searchValue) => this.customSearch(searchValue),
    // table's internal filterList
    confirmFilters: true,

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => this.handleFilterSubmit(applyNewFilters)}
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      //// console.log('onFilterConfirm');
      // console.log('filterList', filterList);
    },

    onFilterDialogOpen: () => {
      //// console.log('filter dialog opened');
    },
    onFilterDialogClose: () => {
      //// console.log('filter dialog closed');
    },
    customToolbar: () => {
      return (
        <>
          {
            <>
              {largeModal === true ? (
                <a
                  href="#"
                  style={{ backgroundColor: "#008000", color: "white" }}
                  onClick={(e) => opnAddNewUserModal(e)}
                  className="caret btn-sm mr-10"
                >
                  ADD <i className="zmdi zmdi-lus"></i>
                </a>
              ) : (
                <a
                  href="#"
                  style={{
                    backgroundColor: "#008000",
                    color: "white",
                    fontSize: "medium",
                  }}
                  onClick={(e) => {
                    opnAddNewUserModal(e);
                    setOutletDetails({});
                    setOutletBankNameValue({});
                  }}
                  className="caret btn-sm mr-10"
                >
                  Create Order <i className="zmdi zmdi-lus"></i>
                </a>
              )}
            </>
          }
        </>
      );
    },
    // onChangeRowsPerPage: onChangeRowsPerPage,
    // sortOrder: {
    // 	name: sort,
    // 	direction: sortByAscending ? "asc" : "desc",
    // },

    //Search Query for list

    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //   // console.log(searchText);
    //   return (
    // 	<>
    // 	  <CustomSearchRender
    // 		debounceWait={500}
    // 		searchText={searchText}
    // 		onSearch={this.handleSearch}
    // 		onHide={hideSearch}
    // 		options={options}
    // 		onClear={this.handleClear}
    // 		searchField={this.state.searchField}
    // 		searchValue={this.state.searchValue}
    // 		fields={this.state.fields}
    // 		handleFieldChange={this.handleFieldChange}
    // 	  />
    // 	</>
    //   );
    // },
  };

  return (
    <>
      {largeModal === false ? (
        <RctCollapsibleCard fullBlock>
          <RctCollapsibleCard fullBlock>
            <MuiThemeProvider theme={themeTable}>
              <MUIDataTable
                title={"Order List"}
                data={orderdetails}
                columns={columns}
                options={options}
                columOrder={columns}
              />
            </MuiThemeProvider>
          </RctCollapsibleCard>
        </RctCollapsibleCard>
      ) : (
        <>
          <RctCollapsibleCard fullBlock>
            <RctCollapsibleCard fullBlock>
              <div className="mb-sm-4 d-flex flex-wrap align-items-center text-head">
                <h2 className="mb-3 me-auto" style={{ fontFamily: "Poppins" }}>
                  Create Order
                </h2>
                {largeModal === true && (
                  <button
                    className="btn btn-primary btn-rounded me-3 mb-2"
                    style={{ backgroundColor: "#008000" }}
                    onClick={() => {
                      setLargeModal(!largeModal);
                      setIsedit(false);
                      setIsview(false);
                      setErrors({});
                    }}
                  >
                    {" "}
                    Back{" "}
                  </button>
                )}
              </div>

              {/* <Stepper
                alternativeLabel
                nonLinear
                className="stepper-rtl"
                activeStep={activeStep}
              >
                {steps.map((step, index) => {
                  const labelProps = {};
                  const stepProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography
                        variant="caption"
                        align="center"
                        style={{ display: "block" }}
                      >
                        optional
                      </Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={step} {...props}>
                      <StepButton
                        onClick={() => handleStep(index)}
                        {...stepProps}
                      >
                        {step}
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper> */}
              {/*  <div className="pl-40">
                <p>{getStepContent(activeStep)}</p>
              </div> */}

              <div className="row">
                <Col xl="6">
                  <Card>
                    <Card.Header className="text-white bg-secondary">
                      <Card.Title style={{ color: "white" }}>
                        ORDER DETAILS
                      </Card.Title>
                      {/* <i
                        className="fas fa-redo"
                        onClick={() => {
                          console.log("finallog123", outletDetails);
                          saveupdateoutlet();
                        }} 
                      ></i> */}
                    </Card.Header>
                    <Card.Body className="mb-0 bg-green-light">
                      <Card.Text style={{ fontSize: "medium" }}>
                        <div class="col-sm form-group">
                          <label
                            as="a"
                            variant="badge badge-rounded badge-danger"
                          >
                            Name
                            <span class="text-warning">*</span>
                          </label>
                          <br />
                          <Input
                            type="text"
                            name="customerName"
                            id="customerName"
                            placeholder="Name"
                            maxLength="20"
                            value={outletDetails?.outletName}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) =>
                              onChangeCommonpopup("outletName", e.target.value)
                            }
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["outletName"]}
                          </span>
                        </div>
                        <div class="col-sm form-group">
                          <label
                            as="d"
                            variant="badge badge-rounded badge-danger"
                          >
                            {" "}
                            Mobile Number
                            <span class="text-warning">*</span>
                          </label>
                          <br />
                          <Input
                            type="text"
                            name="mobilenumber"
                            id="mobilenumber"
                            placeholder="Enter Mobile Number"
                            maxLength="20"
                            value={outletDetails?.outletContactPerson}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) =>
                              onChangeCommonpopup(
                                "outletContactPerson",
                                e.target.value
                              )
                            }
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["outletContactPerson"]}
                          </span>
                        </div>
                        <div class="col-sm form-group">
                          <label
                            as="d"
                            variant="badge badge-rounded badge-danger"
                          >
                            {" "}
                            Alternative Mobile No
                            <span class="text-warning">*</span>
                          </label>
                          <br />
                          <Input
                            type="text"
                            name="mobilenumber"
                            id="mobilenumber"
                            placeholder="Enter Mobile Number"
                            maxLength="30"
                            value={outletDetails?.outletEmailId}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) =>
                              onChangeCommonpopup(
                                "outletEmailId",
                                e.target.value
                              )
                            }
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["outletEmailId"]}
                          </span>
                        </div>

                        {/* <div class="col-sm form-group">
                          <label
                            as="d"
                            variant="badge badge-rounded badge-danger"
                          >
                            {" "}
                            Mobile Number
                            <span class="text-warning">*</span>
                          </label>

                          <br />
                          <Input
                            type="text"
                            name="MobileNumber"
                            id="MobileNumber"
                            placeholder="Enter Mobile Number"
                            maxLength="10"
                            value={outletDetails?.outletMobileNumber}
                            required
                            style={{ backgroundColor: isView && "#e9ecef" }}
                            onChange={(e) =>
                              onChangeCommonpopup(
                                "outletMobileNumber",
                                e.target.value
                              )
                            }
                            disabled={isView}
                            autoComplete="off"
                          />
                          <span style={{ color: "red" }}>
                            {errors["outletMobileNumber"]}
                          </span>
                        </div> */}

                        {/* <div class="col-sm form-group">
                          <label
                            as="d"
                            variant="badge badge-rounded badge-danger"
                          >
                            {" "}
                            Food Category
                            <span class="text-warning">*</span>
                          </label>
                          <br />

                          <div className="basic-form">
                            <div className="form-group">
                              <div className="form-check form-check-inline">
                                <label className="form-check-label">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    onChange={(e) => {
                                      onChangeCommonpopup(
                                        "outletfoodVegcategory",
                                        !outletDetails?.outletfoodVegcategory
                                      );
                                    }}
                                    checked={
                                      outletDetails?.outletfoodVegcategory
                                    }
                                  />
                                  Veg
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <label className="form-check-label">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    onChange={(e) => {
                                      onChangeCommonpopup(
                                        "outletfoodNonVegcategory",
                                        !outletDetails?.outletfoodNonVegcategory
                                      );
                                    }}
                                    checked={
                                      outletDetails?.outletfoodNonVegcategory
                                    }
                                  />
                                  Non-Veg
                                </label>
                              </div>
                            </div>
                          </div>
                        </div> */}

                        {/* {isView === false ? (
                          <div class="col-sm form-group">
                            <label
                              as="d"
                              variant="badge badge-rounded badge-danger"
                            >
                              Outlet Image
                            </label>
                            <br />
                            <Input
                              placeholder="upload file"
                              type="file"
                              id="multiMediaFile"
                              name="multiMediaFile"
                              // accept=".pdf, .PDF, .Pdf"
                              onChange={(e) => {
                                onChangeCommonpopupFile(
                                  "outletinteriorsPhoto",
                                  e
                                );
                              }}
                            />
                          </div>
                        ) : (
                          <div class="col-sm form-group">
                            <label
                              as="d"
                              variant="badge badge-rounded badge-danger"
                            >
                              View Image
                            </label>
                            <br />

                            {outletDetails.outletFssaiFilePath ? (
                              <>
                                <img
                                  src={outletDetails?.outletFssaiFilePath}
                                  onClick={() => {
                                    setOpenImagePopup(!openImagePopup);
                                    setTempModalPopupValue(
                                      outletDetails?.outletFssaiFilePath
                                    );
                                  }}
                                  width="30%"
                                  height="30%"
                                  target="blank"
                                />
                              </>
                            ) : (
                              "Image not available"
                            )}
                          </div>
                        )} */}
                      </Card.Text>
                      <br /> <br />
                    </Card.Body>
                  </Card>
                </Col>


                {/*  <div>
                  <Col xl="12">
                    <Map
                      center={{ lat: 13.018916, lng: 80.207064 }}
                      reRender={reRender}
                      height="300px"
                      zoom={22}
                    />
                  </Col>
                </div> */}
              </div>

              <div className="row">
                <div class="col-sm-3 col-md-6 col-lg-4">
                  <div style={{ paddingLeft: "780px" }}>
                    <Button
                      variant="contained"
                      className="btn-danger"
                      onClick={() => {
                        setOutletDetails({});
                        setOutletBankNameValue({});
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </div>

                <div class="col-sm-9 col-md-6 col-lg-8">
                  <div style={{ paddingLeft: "500px" }}>
                    {isView === false && isedit === false && (
                      <Button
                        variant="contained"
                        // className="btn-info text-white me-3"
                        disabled={!formIsValid}
                        style={{ backgroundColor: "#008000" }}
                        className={
                          !formIsValid
                            ? "btn-disabled"
                            : "btn-info text-white me-3"
                        }
                        onClick={() => {
                          console.log("finallog", outletDetails);
                          saveupdateoutlet();
                        }}
                      >
                        Save Order
                      </Button>
                    )}
                    {isedit === true && (
                      <Button
                        variant="contained"
                        className="btn-success text-white me-3"
                        // disabled={!formIsValid}
                        style={{ backgroundColor: "#008000" }}
                        // className={!formIsValid ? 'btn-disabled' : 'btn-info text-white me-3'}
                        onClick={() => {
                          saveupdateoutlet();
                        }}
                      >
                        Update
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <Button
                    variant="contained"
                    className="btn-danger"
                    style={{ marginLeft: "412px" }}
                    onClick={() => {
                      console.log("finallog", outletDetails)
                    }}
                  >
                    Clear All
                  </Button>
                </div>

                <div class="col-sm-6 col-md-6 col-lg-6">
                  {isView === false && isedit === false && (
                    <Button
                      variant="contained"
                      disabled={!formIsValid}
                      className={!formIsValid ? 'btn-disabled' : 'btn-success text-white me-3'}
                      onClick={() => {
                        console.log("finallog", outletDetails)
                        saveupdateoutlet()
                      }}
                    >
                      Save Outlet
                    </Button>
                  )}
                  {isView === false && isedit === true && (
                    <Button
                      variant="contained"
                      className="btn-success text-white me-3"
                      // disabled={!formIsValid}
                      style={{ backgroundColor: "#008000" }}
                      // className={!formIsValid ? 'btn-disabled' : 'btn-info text-white me-3'}
                      onClick={() => {
                        saveupdateoutlet()
                      }}
                    >
                      Update
                    </Button>
                  )}
                </div>
              </div> */}
              {/* </div> */}
            </RctCollapsibleCard>
          </RctCollapsibleCard>
        </>
      )}
      <Modal
        isOpen={openImagePopup}
        toggle={() => onClose()}
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader>
          <>
            {tempModalPopupValue != "" ? (
              <>
                {chkImgFile(tempModalPopupValue) ? (
                  <>
                    <a href={tempModalPopupValue} download target="_blank">
                      Download Image
                    </a>
                    <i
                      className="ti-close"
                      onClick={onClose}
                      style={{
                        paddingTop: "10px",
                        paddingLeft: "599px",
                        color: "black",
                        fontSize: "medium",
                      }}
                    ></i>
                    <br />
                    <ReactPanZoom image={tempModalPopupValue} alt="image" />
                  </>
                ) : (
                  <iframe
                    src={tempModalPopupValue}
                    width="100%"
                    height="400px"
                  ></iframe>
                )}
              </>
            ) : (
              <p>File Not Available</p>
            )}
          </>
        </ModalHeader>
      </Modal>
    </>
  );
};
export default OrderList;
